import { AutogenModelAvailTractDetail, AutogenRowAvailTractDetail } from "./autogen/AutogenModelAvailTractDetail";

export class ModelAvailTractDetail extends AutogenModelAvailTractDetail<RowAvailTractDetail> {
	constructor() {
		super(RowAvailTractDetail);
	}
}

export class RowAvailTractDetail extends AutogenRowAvailTractDetail {
}